import Controller from '@ember/controller';
import { action } from '@ember/object';
import { type JournalSegmentsIndexRouteModel } from 'donor-elf-web/routes/funds/fund/journals/journal/segments/index';
import { service } from '@ember/service';
import RouterService from '@ember/routing/router-service';
import { tracked } from '@glimmer/tracking';
import Changeset from 'ember-changeset';
import lookupValidator from 'ember-changeset-validations';
import { validatePresence } from 'ember-changeset-validations/validators';

let validation = {
  name: validatePresence({
    presence: true,
    message: 'Enter a name for the segment',
  }),
};

export const journalSegmentIntroText =
  'Journal Segments allow you to group contacts together in a Journal. Segments act very similar to the Groups on the contacts, but the main difference is Journal Segments are specific to an individual Journal.';

export default class JournalSegmentsIndexController extends Controller {
  declare model: JournalSegmentsIndexRouteModel;

  @service declare router: RouterService;

  @tracked showValidationErrors = false;
  newSegmentChangeset: any;

  journalSegmentIntroText = journalSegmentIntroText;

  @action
  templateDidInsert() {
    this.showValidationErrors = false;
    this.newSegmentChangeset = new Changeset(
      { name: '' },
      lookupValidator(validation),
      validation,
    );
  }

  @action
  async handleSaveNewSegment() {
    await this.newSegmentChangeset.validate();
    if (this.newSegmentChangeset.get('isValid')) {
      let segmentName = this.newSegmentChangeset.get('name');
      this.router.transitionTo(
        'funds.fund.journals.journal.segments.segment',
        segmentName,
      );
    } else {
      this.showValidationErrors = true;
    }
  }
}
